var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AVAILABLE_SORTS } from '../../entries/available-sorts';
import { ControlValueAccessor } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
var DEFAULT_VALUE = { column: 'updated_at', direction: 'desc' };
var EntriesSortButtonComponent = /** @class */ (function () {
    function EntriesSortButtonComponent() {
        this.btnDisabled = false;
        this.availableSorts = AVAILABLE_SORTS;
        this.sort$ = new BehaviorSubject(DEFAULT_VALUE);
    }
    EntriesSortButtonComponent.prototype.changeSort = function (column) {
        this.sort$.next(__assign({}, this.sort$.value, { column: column.name }));
        this.propagateChange(this.sort$.value);
    };
    EntriesSortButtonComponent.prototype.changeDirection = function (direction) {
        this.sort$.next(__assign({}, this.sort$.value, { direction: direction }));
        this.propagateChange(this.sort$.value);
    };
    EntriesSortButtonComponent.prototype.getSortViewName = function (column) {
        return this.availableSorts.find(function (sort) { return sort.name === column; }).viewName;
    };
    EntriesSortButtonComponent.prototype.writeValue = function (value) {
        this.sort$.next(value || DEFAULT_VALUE);
    };
    EntriesSortButtonComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    EntriesSortButtonComponent.prototype.registerOnTouched = function () { };
    return EntriesSortButtonComponent;
}());
export { EntriesSortButtonComponent };
